import SIP from "sip.js";
import SessionDescriptionHandler from "../webrtc/sessionDescriptionHandler";
import SessionDescriptionHandlerTemasys from "../webrtc/sessionDescriptionHandlerTemasys";
import AdapterJS from "adapterjs";
import SessionDescriptionHandlerNoWebRtc from "../webrtc/sessionDescriptionHandlerNoWebRtc";
import Storage from "../misc/storage";
import { sipError, clearSipError } from "./networkActions";
import { SIP_STATE, CALL_STATE } from "../reducers/sipReducer";
import { isKiosk } from "../reducers/configReducer";
import { switchFreeswitch, unBindLocalStream } from "./configActions";
import SipService from "../services/sipService";
import ActionTypes from "../actions/actionTypes";
import NetworkService from "../services/networkService";
import findContactFromSip from "../modules/findContactFromSip";
import waitForDom from "../modules/wait-for-dom";

/** Create and register sip user agent */
export function register(options) {
  return (dispatch, getstate) => {
    var system = getstate().config.system;

    if (!options) {
      options = getUserAgentOptions(
        getstate().user,
        system,
        getstate,
        dispatch
      );
    }
    //        options.extraHeaders.push(getRouteHeader());

    var userAgent = new SIP.UA(options);

    dispatch({
      type: ActionTypes.SIP_REGISTER_STARTED,
      payload: {
        userAgent: userAgent,
      },
    });

    userAgent
      .on("connected", () => {
        console.debug("websocket connected ");
      })
      .on("disconnected", () => {
        console.debug("Unhandled disconnect event ", arguments);
      })
      .on("registered", () => {
        if (getstate().sip.sipState === "UNREGISTERED") {
          dispatch(updateRegisteredEndpoint());
          dispatch({
            type: ActionTypes.SIP_REGISTER_SUCCESS,
            payload: {
              userAgent: userAgent,
            },
          });
        }
      })
      .on("invite", session => {
        if (
          getstate().sip.sipState === "IDLE" ||
          (getstate().sip.sipState === "IN_CALL" &&
            getstate().sip.callState === "TERMINATED_REMOTE")
        ) {
          session
            .on("cancel", () => {
              if (getstate().sip.callState === CALL_STATE.INCOMING_CALL) {
                dispatch({ type: ActionTypes.SIP_CALL_CANCELED_REMOTE });
              }
            })
            .on("failed", () => {
              if (getstate().sip.callState === CALL_STATE.INCOMING_CALL) {
                dispatch({ type: ActionTypes.SIP_CALL_FAILED_REMOTE });
                dispatch(unBindLocalStream());
              } else if (getstate().sip.callState === CALL_STATE.ACCEPTED) {
                dispatch({ type: ActionTypes.SIP_CALL_FAILED });
              }
            })
            .on("bye", () => {
              if (getstate().sip.callState === CALL_STATE.ACCEPTED) {
                dispatch({ type: ActionTypes.SIP_CALL_TERMINATED_REMOTE });
                dispatch(unBindLocalStream());
              }
            })
            .on("terminated", () => {
              console.log("Terminated");
            })
            .on("rejected", () => {
              console.log("Rejected");
            })
            .on("accepted", response => {
              var mmxCallId = getMmxTextHeaders(session.transaction.request);
              if (getstate().sip.safetextSender) {
                getstate().sip.safetextSender.reset();
                if (mmxCallId !== null) {
                  getstate().sip.safetextSender.mmxCallId = mmxCallId;
                }
                getstate().sip.safetextSender.uri = session.remoteIdentity.uri;
              }
              var negotiated = getNegotiated(response);

              if (mmxCallId) {
                negotiated.text = true;
              } else {
                negotiated.text = false;
              }

              //If the user set use audio to false in settings
              if (getstate().setting.user.WEB_AUDIO === "false") {
                negotiated.audio = false;
              }

              //If the user set use video to false in settings
              if (getstate().setting.user.WEB_VIDEO === "false") {
                negotiated.video = false;
              }

              dispatch({
                type: ActionTypes.SIP_CALL_SET_NEGOTIATED,
                payload: {
                  negotiated: negotiated,
                  MMXCALLID: mmxCallId,
                },
              });

              if (getstate().config.browser.name === "ie") {
                dispatch(tryBindMedia(getstate, {}, dispatch));
              }
            });

          dispatch({
            type: ActionTypes.SIP_INVITE_RECIEVED,
            payload: {
              session: session,
              callB: session.remoteIdentity.displayName
                ? session.remoteIdentity.displayName
                : session.request.data.substring(
                    session.request.data.indexOf('From: "" <sip:') + 14,
                    session.request.data.indexOf(">;tag=")
                  ),
            },
          });
        } else {
          session.reject({ statusCode: 486 }); //Send busy response
        }
      })
      .on("registrationFailed", (cause, description) => {
        dispatch(updateRegisteredEndpoint(0));
        dispatch({
          type: ActionTypes.SIP_REGISTER_FAILED,
          payload: {
            cause: cause,
            description: description,
          },
        });
      })
      .on("unregistered", () => {
        dispatch(updateRegisteredEndpoint(0));
        dispatch({ type: ActionTypes.SIP_UNREGISTERED });
      })
      .on("message", message => {
        var txt = "";

        for (var i = 0; i < message.body.length; i++) {
          var c = message.body[i];
          if (c.charCodeAt(0) === 7) {
            dispatch({
              type: ActionTypes.CALL_KNOCK_KNOCK,
              payload: true,
            });
          } else if (c.charCodeAt(0) === 8) {
            if (txt && txt.length > 0) {
              dispatch({
                type: ActionTypes.CALL_TEXT_MSG_IN,
                payload: txt,
              });
            }
            dispatch({
              type: ActionTypes.CALL_TEXT_MSG_IN_DEL,
            });
            txt = "";
          } else {
            txt = txt + c;
          }
        }

        dispatch({
          type: ActionTypes.CALL_TEXT_MSG_IN,
          payload: txt,
        });
      });

    userAgent = userAgent.register();

    getstate().sip.safetextSender.userAgent = userAgent;
  };
}

export function acceptCall(options) {
  return (dispatch, getstate) => {
    if (getstate().network.sipError) {
      dispatch(clearSipError);
    }

    if (getstate().config.text) {
      ///////Needed to send safetext
      if (!options) {
        options = { extraHeaders: [] };
      } else if (!options.extraHeaders) {
        options.extraHeaders = [];
      }
      options.extraHeaders.push("P-MMX-Text-Response: 1");
      options.extraHeaders.push("P-Safe-Text: 1");
      //////////////////////////////////////////////////
    }

    var sessionDescriptionHandlerOptions = getSessionDescriptionHandlerOptions(
      getstate
    );
    options.sessionDescriptionHandlerOptions = sessionDescriptionHandlerOptions;

    var session = getstate().sip.session;
    session.status = 4;
    session.accept(options);

    if (session) {
      if (session.sessionDescriptionHandler) {
        if (session.sessionDescriptionHandler.peerConnection !== undefined) {
          session.sessionDescriptionHandler.peerConnection.ontrack = function(
            event
          ) {
            let remoteStream = event.streams[0];
            if (remoteStream) {
              dispatch(tryBindMedia(getstate, remoteStream, dispatch));
            }
          };
        }

        dispatch({
          type: ActionTypes.SIP_CALL_ACCEPTED_LOCAL,
          payload: {
            negotiated: {
              audio:
                getstate().config.audio &&
                getstate().setting.user.WEB_AUDIO === "true",
              video:
                getstate().config.video &&
                getstate().setting.user.WEB_VIDEO === "true",
              text: getstate().config.mode.safetext,
            },
            audio: getstate().config.audio,
            video: getstate().config.video,
            text: getstate().config.mode.safetext,
          },
        });
      }
    }
  };
}

export function online() {
  return (dispatch, getstate) => {
    var online = {
      type: ActionTypes.SIP_ONLINE,
      payload: true,
    };

    var offline = {
      type: ActionTypes.SIP_ONLINE,
      payload: false,
    };

    if (getstate().sip.userAgent != null) {
      if (
        getstate().sip.userAgent.isRegistered() === true &&
        getstate().sip.online === false
      ) {
        dispatch(online);
        return;
      }
      return;
    }

    if (getstate().sip.online === true) {
      dispatch(offline);
    }

    return;
  };
}

export function muteAudio() {
  return (dispatch, getstate) => {
    if (
      !getstate().sip.session.sessionDescriptionHandler ||
      !getstate().sip.session.sessionDescriptionHandler.peerConnection
    )
      return;

    var pc = getstate().sip.session.sessionDescriptionHandler.peerConnection;

    if (pc.getSenders) {
      pc.getSenders().forEach(function(sender) {
        if (sender.track && sender.track.kind === "audio") {
          sender.track.enabled = !sender.track.enabled;
        }
      });
    } else {
      pc.getLocalStreams().forEach(function(stream) {
        stream.getAudioTracks().forEach(function(track) {
          track.enabled = !track.enabled;
        });
      });
    }

    dispatch({
      type: ActionTypes.CALL_MUTE_AUDIO,
      payload: {},
    });
  };
}

export function muteVideo() {
  return (dispatch, getstate) => {
    if (
      !getstate().sip.session.sessionDescriptionHandler ||
      !getstate().sip.session.sessionDescriptionHandler.peerConnection
    )
      return;

    var pc = getstate().sip.session.sessionDescriptionHandler.peerConnection;

    if (pc.getSenders) {
      pc.getSenders().forEach(function(sender) {
        if (sender.track && sender.track.kind === "video") {
          sender.track.enabled = !sender.track.enabled;
        }
      });
    } else {
      pc.getLocalStreams().forEach(function(stream) {
        stream.getVideoTracks().forEach(function(track) {
          track.enabled = !track.enabled;
        });
      });
    }

    dispatch({
      type: ActionTypes.CALL_MUTE_VIDEO,
      payload: {},
    });
  };
}

export function stopVideo() {
  return (dispatch, getstate) => {
    if (
      !getstate().sip.session.sessionDescriptionHandler ||
      !getstate().sip.session.sessionDescriptionHandler.peerConnection
    )
      return;

    var pc = getstate().sip.session.sessionDescriptionHandler.peerConnection;
    if (pc.getSenders) {
      pc.getSenders().forEach(function(sender) {
        if (sender.track && sender.track.kind === "video") {
          sender.track.stop();
        }
      });
    } else {
      pc.getLocalStreams().forEach(function(stream) {
        stream.getVideoTracks().forEach(function(track) {
          track.stop();
        });
      });
    }
  };
}

export function stopAudio() {
  return (dispatch, getstate) => {
    if (
      !getstate().sip.session.sessionDescriptionHandler ||
      !getstate().sip.session.sessionDescriptionHandler.peerConnection
    )
      return;

    var pc = getstate().sip.session.sessionDescriptionHandler.peerConnection;
    if (pc.getSenders) {
      pc.getSenders().forEach(function(sender) {
        if (sender.track && sender.track.kind === "audio") {
          sender.track.stop();
        }
      });
    } else {
      pc.getLocalStreams().forEach(function(stream) {
        stream.getAudioTracks().forEach(function(track) {
          track.stop();
        });
      });
    }
  };
}

export function muteRemoteAudio() {
  return (dispatch, getstate) => {
    try {
      var remoteMedia = document.getElementById(getMediaElement(getstate()));
      console.log(remoteMedia);
      if (remoteMedia.volume === 0) {
        remoteMedia.volume = 1;
      } else {
        remoteMedia.volume = 0;
      }
    } catch (exc) {
      console.log(exc);
    }
    dispatch({
      type: ActionTypes.CALL_MUTE_REMOTE_AUDIO,
      payload: {},
    });
  };
}

export function stopRemoteAudio() {
  return (dispatch, getstate) => {
    try {
      var remoteMedia = document.getElementById(getMediaElement(getstate()));
      if (remoteMedia !== null) remoteMedia.volume = 0;
    } catch (exc) {
      console.log(exc);
    }
  };
}

function getSessionDescriptionHandlerOptions(getstate, audio, video, text) {
  if (audio == null) audio = true;
  if (video == null) video = true;
  if (text == null) text = true;

  //Branding config
  if (
    getstate().config.webrtc === false &&
    getstate().config.temasys === false
  ) {
    audio = false;
    video = false;
  }

  //Branding config
  if (getstate().config.audio === false) {
    audio = false;
  }
  //If user has granted access to mic
  if (audio === true && getstate().config.audio === false) {
    audio = false;
  }

  //If the user set use audio to false in settings
  if (
    !getstate().config.mode.kiosk &&
    getstate().setting.user.WEB_AUDIO === "false"
  ) {
    audio = false;
  }

  //Branding config
  if (getstate().config.video === false) {
    video = false;
  }
  //If user has granted access to camera
  if (video === true && getstate().config.video === false) {
    video = false;
  }

  //If the user set use video to false in settings and not kiosk
  if (
    !getstate().config.mode.kiosk &&
    getstate().setting.user.WEB_VIDEO === "false"
  ) {
    video = false;
  }

  if (getstate().config.mode.safetext === false) {
    text = false;
  }

  var audioconf = false;
  if (audio === true) {
    audioconf = true;
  }

  var videoconf = false;
  if (video === true) {
    videoconf = true;
  }

  var sessionDescriptionHandlerOptions = {
    alwaysAcquireMediaFirst: true,
    constraints: {
      audio: audioconf,
      video: videoconf,
    },
    mmx: {
      audio: audio,
      video: video,
      text: text,
    },
    modifiers: [
      //SIP.Web.Modifiers.addMidLines
    ],
  };

  return sessionDescriptionHandlerOptions;
}

function checkIfIPv6(ip) {
  if (/:+/.test(ip)) {
    return true;
  } else {
    return false;
  }
}

export function call(
  to,
  audio,
  video,
  text,
  ivrInput = null,
  externalReference = null
) {
  return (dispatch, getstate) => {
    if (getstate().network.freeswitchError || getstate().network.serverError) {
      alert(getstate().config.text("error.cantcall"));
      return;
    }

    if (getstate().network.sipError) {
      dispatch(clearSipError);
    }

    if (to === null || to === "" || to === undefined) {
      console.error("To is null");
      return;
    }

    //Must use domain
    if (to.indexOf("@") === -1) {
      var domain = "";
      //Check for multiple SIP-addresses in properties
      if (getstate().user.properties.SIP_ADDRESS.indexOf("|") > -1) {
        domain = getstate()
          .user.properties.SIP_ADDRESS.split("|")[0]
          .split("@")[1];
      } else {
        domain = getstate().user.properties.SIP_ADDRESS.split("@")[1];
      }

      to = to + "@" + domain;
    }

    var options = {};
    var modifiers = [];
    options.extraHeaders = [];

    if (getstate().config.mode.safetext) {
      ///////Needed to send safetext
      options.extraHeaders.push("P-MMX-Text-Offer: 1");
      options.extraHeaders.push("P-Safe-Text: 1");
    }
    //       options.extraHeaders.push(getRouteHeader());

    //////////////////////////////////////////////////

    if (isKiosk(getstate()) && externalReference !== null) {
      const callInfoHeader = `P-Call-Info: <sip:0.0.0.0>;USER-REFERENCE=${externalReference};purpose=USERINFO`;
      options.extraHeaders.push(callInfoHeader);
    }

    if (
      getstate().config.localIp !== "" &&
      getstate().config.localIp !== null
    ) {
      const ip = getstate().config.localIp;
      let ipAddressHeader = "";
      if (checkIfIPv6(ip)) {
        ipAddressHeader = `P-Call-Info: <sip:[${ip}]>; purpose=trs-user-ip`;
      } else {
        ipAddressHeader = `P-Call-Info: <sip:${ip}>; purpose=trs-user-ip`;
      }
      options.extraHeaders.push(ipAddressHeader);
    }

    var sessionDescriptionHandlerOptions = getSessionDescriptionHandlerOptions(
      getstate,
      audio,
      video,
      text
    );
    options.sessionDescriptionHandlerOptions = sessionDescriptionHandlerOptions;

    if (
      !sessionDescriptionHandlerOptions.mmx.audio &&
      !sessionDescriptionHandlerOptions.mmx.video &&
      !sessionDescriptionHandlerOptions.mmx.text
    ) {
      alert(getstate().config.text("error.cantcall_without_media"));
      return;
    }

    var canCall = true;
    if (!canCall && getstate().sip.sipState === SIP_STATE.IDLE) canCall = true;
    if (
      !canCall &&
      getstate().sip.sipState === SIP_STATE.IN_CALL &&
      getstate().sip.callState === CALL_STATE.REJECTED_REMOTE
    )
      canCall = true;
    if (
      !canCall &&
      getstate().sip.sipState === SIP_STATE.IN_CALL &&
      getstate().sip.callState === CALL_STATE.CANCELED_REMOTE
    )
      canCall = true;
    if (
      !canCall &&
      getstate().sip.sipState === SIP_STATE.IN_CALL &&
      getstate().sip.callState === CALL_STATE.TERMINATED_REMOTE
    )
      canCall = true;

    if (canCall) {
      var session = getstate().sip.userAgent.invite(to, options, modifiers);

      let remoteStream = null;
      session
        .on("progress", () => {
          if (session.sessionDescriptionHandler.peerConnection !== undefined) {
            // If video is allowed (not phone and width >= 992px)
            session.sessionDescriptionHandler.peerConnection.ontrack = function(
              event
            ) {
              remoteStream = event.streams[0];
            };
          }
        })
        .on("rejected", () => {
          if (getstate().sip.safetextSender) {
            getstate().sip.safetextSender.reset();
          }
          if (getstate().sip.callState === CALL_STATE.CALLING) {
            dispatch({ type: ActionTypes.SIP_CALL_REJECTED_REMOTE });
          }
        })
        .on("failed", request => {
          if (getstate().sip.safetextSender) {
            getstate().sip.safetextSender.reset();
          }
          if (getstate().sip.callState === CALL_STATE.CALLING) {
            dispatch({ type: ActionTypes.SIP_CALL_FAILED });
          }
        })
        .on("accepted", response => {
          if (getstate().sip.safetextSender) {
            getstate().sip.safetextSender.reset();
            var negotiated = getNegotiated(response);
            var mmxCallId = getMmxTextHeaders(response);
            if (mmxCallId == null) {
              negotiated.text = false;
            } else {
              negotiated.text = true;
              getstate().sip.safetextSender.mmxCallId = mmxCallId;
            }
            getstate().sip.safetextSender.uri = session.remoteIdentity.uri;
          }
          dispatch({
            type: ActionTypes.SIP_CALL_ACCEPTED_REMOTE,
            payload: {
              negotiated: negotiated,
              MMXCALLID: getMmxTextHeaders(response),
            },
          });

          if (ivrInput) {
            dispatch(sendIVRinput(ivrInput));
          }

          if (
            options.sessionDescriptionHandlerOptions.mmx.audio === true ||
            options.sessionDescriptionHandlerOptions.mmx.video === true
          ) {
            dispatch(tryBindMedia(getstate, remoteStream, dispatch));
          }
        })
        .on("bye", () => {
          if (getstate().sip.safetextSender) {
            getstate().sip.safetextSender.reset();
          }
          if (getstate().sip.callState === CALL_STATE.ACCEPTED) {
            dispatch({ type: ActionTypes.SIP_CALL_TERMINATED_REMOTE });
            dispatch(unBindLocalStream());
          }
        });

      dispatch({
        type: ActionTypes.SIP_CALLING,
        payload: {
          session: session,
          audio: sessionDescriptionHandlerOptions.mmx.audio,
          video: sessionDescriptionHandlerOptions.mmx.video,
          text: sessionDescriptionHandlerOptions.mmx.text,
          options: {
            textVisible: getstate().config.mode.setting_text_visible_by_default,
          },
          callB: to,
          callBName: findContactFromSip(
            getstate().service.services,
            getstate().contact.contacts,
            to
          ),
        },
      });
    } else {
      console.error(
        "Cant call, because the status is " + getstate().sip.sipState
      );
    }
  };
}

export function sendMessage(message) {
  return (dispatch, getstate) => {
    if (getstate().sip.safetextSender) {
      if (message && message.length > 1000) {
        var tolongtext = getstate().config.text("call.toolongtext");
        dispatch({
          type: ActionTypes.CALL_TEXT_MSG_OUT,
          payload: tolongtext,
        });
        getstate().sip.safetextSender.send(tolongtext);
        return;
      }

      var txt = "";
      for (var i = 0; i < message.length; i++) {
        var c = message[i];
        if (c.charCodeAt(0) === 8) {
          if (txt && txt.length > 0) {
            dispatch({
              type: ActionTypes.CALL_TEXT_MSG_OUT,
              payload: txt,
            });
          }
          dispatch({
            type: ActionTypes.CALL_TEXT_MSG_OUT_DEL,
          });
          txt = "";
        } else {
          txt = txt + c;
        }
      }

      dispatch({
        type: ActionTypes.CALL_TEXT_MSG_OUT,
        payload: txt,
      });

      getstate().sip.safetextSender.send(message);

      dispatch({ type: ActionTypes.SIP_MESSAGE_SENT });
    }
  };
}

function sendIVRinput(inputString) {
  return (dispatch, getstate) => {
    var input = inputString.split(",");
    sendInput(getstate, input, 0);
  };
}

function sendInput(getstate, input, index) {
  if (index < input.length) {
    if (getstate().sip.safetextSender.mmxCallId) {
      getstate().sip.safetextSender.send(input[index]);
    } else {
      var i;
      for (i = 0; i < input[index].length; i++) {
        getstate().sip.session.dtmf(input[index][i]);
      }
    }
    setTimeout(() => sendInput(getstate, input, index + 1), 100);
  }
}

export function ping() {
  return (dispatch, getstate) => {
    //TODO fixed timeout in websockets
    //Nils: Some webbrowser closes the websocket when no data has arrived in 30sec(ie and edge)
    //This ping sends an empty space on the websocket
    //This can mess things up on the server side so it is no good solution :(
    //Chrome/FF seems to work
    //Propably a result to what kind of header information that is sent in the websocket init
    var ua = getstate().sip.userAgent;
    if (ua.transport.ws) {
      ua.transport.ws.send(" ");
      dispatch({
        type: ActionTypes.SIP_WS_PING,
        payload: getstate().config.browser.name,
      });
    }
  };
}

export function rejectCall(options) {
  return (dispatch, getstate) => {
    if (!getstate().sip.session) {
      console.warn(
        "Trying to reject call when there is no incoming call to reject."
      );
      return;
    }
    try {
      if (getstate().sip.callState === CALL_STATE.INCOMING_CALL) {
        dispatch({ type: ActionTypes.SIP_CALL_REJECTED_LOCAL });
      }
      dispatch({ type: ActionTypes.SIP_CALL_COMPLETED });
      getstate().sip.session.status = 4;
      getstate().sip.session.reject(options);
    } catch (e) {
      console.debug(
        "Could not send reject on session, will try to terminate",
        e
      );
      terminateCall(options);
    }
  };
}

export function cancelCall(options) {
  return (dispatch, getstate) => {
    if (!getstate().sip.session) {
      console.warn(
        "Trying to cancel call when there is no outgoing call to cancel."
      );
      return;
    }
    try {
      if (getstate().sip.callState === CALL_STATE.CALLING) {
        dispatch({ type: ActionTypes.SIP_CALL_CANCELED_LOCAL });
      }
      dispatch({ type: ActionTypes.SIP_CALL_COMPLETED });
      getstate().sip.session.cancel(options);
    } catch (e) {
      console.debug(
        "Could not send cancel on session, will try to terminate",
        e
      );
      terminateCall(options);
    }
  };
}

export function endCall(options) {
  return (dispatch, getstate) => {
    if (getstate().sip.sipState !== "IN_CALL" || !getstate().sip.session) {
      console.warn("Trying to send BYE but not in call.");
      return;
    }
    try {
      if (getstate().sip.callState === CALL_STATE.ACCEPTED) {
        dispatch({ type: ActionTypes.SIP_CALL_TERMINATED_LOCAL });
      }
      dispatch({ type: ActionTypes.SIP_CALL_COMPLETED });
      getstate().sip.session.bye(options);
    } catch (e) {
      console.debug("Could not send BYE on session, will try to terminate", e);
      terminateCall(options);
    }
  };
}

export function terminateCall(options) {
  return (dispatch, getstate) => {
    if (!getstate().sip.session) {
      console.warn("Trying to terminate call when there is no call.");
      return;
    }
    dispatch({ type: ActionTypes.SIP_CALL_TERMINATED_LOCAL });
    dispatch({ type: ActionTypes.SIP_CALL_COMPLETED });
    getstate().sip.session.terminate(options);
  };
}

export function unregister() {
  return (dispatch, getstate) => {
    if (getstate().sip.userAgent) {
      getstate().sip.userAgent.unregister();
    }
  };
}

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getUserAgentOptions(user, systemConfig, getstate, dispatch) {
  var sessionid = Storage.session.get("sessionid");
  if (!sessionid || sessionid === null || sessionid === "null") {
    sessionid = uuidv4();
    Storage.session.set("sessionid", sessionid);
  }

  var sessionDescriptionHandlerOptions = getSessionDescriptionHandlerOptions(
    getstate
  );

  var displayname = user.properties.sipAddress;
  if (getstate().user.anonymous === true) {
    displayname = getstate().config.text("common.anonymous");
  }

  let userAgentString = "Web " + getstate().config.version;
  if (getstate().config.browser && getstate().config.browser.os) {
    userAgentString = userAgentString + " " + getstate().config.browser.os;
  }
  if (getstate().config.browser && getstate().config.browser.name) {
    userAgentString = userAgentString + " " + getstate().config.browser.name;
  }
  if (getstate().config.browser && getstate().config.browser.version) {
    userAgentString = userAgentString + " " + getstate().config.browser.version;
  }

  let wsServer = systemConfig.SYS_WEBRTC_SERVER_URI;

  const transportOptions = {
    wsServers: [wsServer],
    traceSip: getstate().config.mode.debug_enabled === true,
    maxReconnectionAttempts: 3,
    reconnectionTimeout: 4,
    keepAliveInterval: 20,
  };

  let uri = getRegisterUri(
      getstate().config.mode.register_with_userpart_from_sip,
      wsServer,
      user.properties.SIP_ADDRESS,
      user.properties.USERNAME,
      sessionid
    );
  let password = user.securityToken;
  let authorizationUser = getstate().config.mode.register_with_userpart_from_sip
      ? getUserpartFromSIP(user.properties.SIP_ADDRESS, sessionid)
      : getUsername(user.properties.USERNAME, sessionid);

  if (getstate().config.mode.opensips === true) {
    uri = user.properties.SIP_ADDRESS;
    password = user.password;
    authorizationUser = user.username;
    if (getstate().config.mode.anonymous_autologin === true) {
      password = getstate().config.anonymous.password;
      authorizationUser = getstate().config.anonymous.user;
    }
  }

  var ret = {
    displayName: displayname,
    uri: uri,
    password: password,
    authorizationUser: authorizationUser,
    originalUri: user.properties.SIP_ADDRESS.split("|")[0],
    register: true,
    log: {
      builtinEnabled: getstate().config.mode.debug_enabled ? true : false,
      level: getstate().config.mode.debug_enabled === true ? "debug" : "log",
      connector: function(level, category, label, content) {
        getSipError(level, category, label, content, dispatch, getstate);
      },
    },
    extraHeaders: [],
//    hackIpInContact: true,
//    hackWssInTransport: true,
    hackIpInContact: false,
    hackWssInTransport: false,
    registerExpires: 600,
    instanceId: sessionid,
    sessionDescriptionHandlerFactoryOptions: sessionDescriptionHandlerOptions,
    userAgentString: userAgentString,
    sessionDescriptionHandlerFactory: function(session, options) {
      options = getSessionDescriptionHandlerOptions(getstate);
      if (
        getstate().config.webrtc === false &&
        getstate().config.temasys ===
          false /*|| !getstate().setting.isUsingMedia*/
      ) {
        return SessionDescriptionHandlerNoWebRtc;
      }
      if (getstate().config.temasys === true) {
        return new SessionDescriptionHandlerTemasys(session, options);
      } else {
        return new SessionDescriptionHandler(session, options);
      }
    },
    transportOptions: transportOptions,
  };
  return ret;
}
/*
function getRouteHeader() {
    //<sip:10.0.75.164:7443;lr;transport=ws>,<sip:10.0.75.28:5060;lr;transport=udp>
    //<sip:sip.test.iotcomms.io:7443;transport=wss>, <sip:rt.nwise.se>
    var routes = [];
    routes.push('<sip:sip.test.iotcomms.io:7443;transport=wss>');
    routes.push('<sip:rt.nwise.se>');
    return 'Route: ' + routes.join(',');
}
*/

function getSipError(level, category, label, content, dispatch, getstate) {
  if (level !== null && content !== null && content !== undefined) {
    if (
      level === "error" &&
      ["unable to acquire streams"].indexOf(content) !== -1
    ) {
      dispatch(sipError(errorMessage(content, getstate)));
    } else if (
      level === "warn" &&
      ["Transport error: [object Event]"].indexOf(content) !== -1
    ) {
      NetworkService.showErrorAlert(dispatch, "freeswitchError");
    } else if (content.indexOf) {
      if (
        level === "log" &&
        content.indexOf("WebSocket") !== -1 &&
        content.indexOf(" connected") !== -1
      ) {
        NetworkService.clearFreeswitchErrorAlert(dispatch);
      } else if (content.indexOf("connection state set to 'error'") !== -1) {
        if (!getstate().config.mode.video) {
          dispatch(switchFreeswitch());
        }
      }
    }
  }
}

const errorMessage = (errorCode, getstate) => {
  switch (errorCode) {
    case "unable to acquire streams":
      return getstate().config.text("error.acquiremedia");
    default:
      return getstate().config.text("error.unknown") + " " + errorCode;
  }
};

function getMediaElement(state) {
  if (
    state.config.audio &&
    (!state.config.video || state.setting.user.WEB_VIDEO === "false")
  ) {
    return "remote-audio";
  }
  return "remote-video";
}

function tryBindMedia(getstate, stream, dispatch) {
  if (getstate().config.mode.video) {
    dispatch(bindLocalMedia());
  }
  if (getstate().config.browser.name === "ie") {
    return bindRemoteMediaIE();
  } else if (getstate().config.browser.name === "edge") {
    return bindRemoteMediaEdge();
  }
  return bindRemoteMedia(stream);
}

function bindRemoteMedia(stream) {
  return (dispatch, getstate) => {
    try {
      var remote = getMediaElement(getstate());
      waitForDom(remote)
        .then(element => {
          console.log("Got dom element. Setting srcObject.");
          element.srcObject = stream;
          element.setAttribute("playsinline", true);
          element.play();
        })
        .catch(err => {
          console.log(`ERROR: ${err}`);
        });
    } catch (exc) {
      console.log(exc);
    }
  };
}

function bindRemoteMediaEdge() {
  return (dispatch, getstate) => {
    try {
      if (
        !getstate().sip.session.sessionDescriptionHandler ||
        !getstate().sip.session.sessionDescriptionHandler.peerConnection
      )
        return;
      var pc = getstate().sip.session.sessionDescriptionHandler.peerConnection;
      var remote = getMediaElement(getstate());
      waitForDom(remote)
        .then(element => {
          console.log("Got dom element. Setting srcObject.");
          element.srcObject = pc.getRemoteStreams()[0];
          element.setAttribute("playsinline", true);
          element.play();
        })
        .catch(err => {
          console.log(`ERROR: ${err}`);
        });
    } catch (exc) {
      console.log(exc);
    }
  };
}

function bindRemoteMediaIE() {
  return (dispatch, getstate) => {
    try {
      if (
        !getstate().sip.session.sessionDescriptionHandler ||
        !getstate().sip.session.sessionDescriptionHandler.peerConnection
      )
        return;
      var pc = getstate().sip.session.sessionDescriptionHandler.peerConnection;
      var remote = getMediaElement(getstate());
      waitForDom(remote)
        .then(element => {
          console.log("Got dom element. Setting srcObject.");
          element.srcObject = pc.getRemoteStreams()[0];
          AdapterJS.attachMediaStream(element, pc.getRemoteStreams()[0]);
          element.setAttribute("playsinline", true);
          element.play();
        })
        .catch(err => {
          console.log(`ERROR: ${err}`);
        });
    } catch (exc) {
      console.log(exc);
    }
  };
}

function bindLocalMedia() {
  return (dispatch, getstate) => {
    try {
      var localStream = null;
      var tryBind = setInterval(() => {
        if (
          getstate().sip.session.sessionDescriptionHandler &&
          getstate().sip.session.sessionDescriptionHandler.peerConnection
        ) {
          var pc = getstate().sip.session.sessionDescriptionHandler
            .peerConnection;

          if (pc.getSenders) {
            pc.getSenders().forEach(function(sender) {
              if (sender.track && sender.track.kind === "video") {
                localStream = new MediaStream();
                localStream.addTrack(sender.track);
              }
            });
          } else {
            pc.getLocalStreams().forEach(function(stream) {
              stream.getVideoTracks().forEach(function(track) {
                localStream = stream;
              });
            });
          }

          if (
            getstate().config.localStream === null &&
            localStream !== null &&
            getstate().sip.callState === "ACCEPTED"
          ) {
            dispatch({
              type: ActionTypes.BIND_LOCAL_STREAM,
              payload: {
                stream: localStream,
              },
            });
            clearInterval(tryBind);
          }
        }
      }, 500); //Try to bind local media when PC is ready
    } catch (exc) {
      console.log(exc);
    }
  };
}

function getRegisterUri(
  useSIP,
  wsServer,
  sipAddress,
  username,
  sessionid,
  port
) {
  if (!wsServer || (!sipAddress && !username)) {
    return null;
  }

  var res = wsServer.split("//");
  var serverres = res[1].split(":");
  serverres = serverres[0].split("/");

  if (!port || port === "" || port === null) {
    if (useSIP) {
      return getUserpartFromSIP(sipAddress, sessionid) + "@" + serverres[0];
    } else {
      return getUsername(username, sessionid) + "@" + serverres[0];
    }
  } else {
    if (useSIP) {
      return (
        getUserpartFromSIP(sipAddress, sessionid) +
        "@" +
        serverres[0] +
        ":" +
        port
      );
    } else {
      return getUsername(username, sessionid) + "@" + serverres[0] + ":" + port;
    }
  }
}

function getUserpartFromSIP(sipAddress, sessionid) {
  if (!sessionid) {
    return sipAddress.split("@")[0];
  } else {
    return sipAddress.split("@")[0] + "." + sessionid;
  }
}

function getUsername(username, sessionid) {
  if (!sessionid) {
    return username;
  } else {
    return username + "." + sessionid;
  }
}

function getMmxTextHeaders(request) {
  if (request && request.hasHeader("P-Mmx-Text-Dst")) {
    return request.getHeader("P-Mmx-Text-Dst");
  } else {
    return null;
  }
}

function getNegotiated(request) {
  var isVideo = true;
  var isAudio = true;

  if (request.body) {
    if (
      request.body.indexOf("m=video 0 ") > -1 ||
      request.body.indexOf("m=video") === -1
    ) {
      isVideo = false;
    }
    if (
      request.body.indexOf("m=audio 0 ") > -1 ||
      request.body.indexOf("m=audio") === -1
    ) {
      isAudio = false;
    }
  } else if (!request.data) {
    if (
      request.indexOf("m=video 0 ") > -1 ||
      request.indexOf("m=video") === -1
    ) {
      isVideo = false;
    }
    if (
      request.indexOf("m=audio 0 ") > -1 ||
      request.indexOf("m=audio") === -1
    ) {
      isAudio = false;
    }
  }
  return {
    audio: isAudio,
    video: isVideo,
  };
}

export function updateRegisteredEndpoint(registerExpires, securityToken) {
  return (dispatch, getstate) => {
    var sessionid = Storage.session.get("sessionid");

    if (!securityToken) {
      securityToken = getstate().user.securityToken;
    }

    if (!securityToken || !sessionid) {
      return;
    }

    if (!registerExpires) {
      registerExpires = 600;
    }

    var contact =
      "sip:" +
      getRegisterUri(
        getstate().config.mode.register_with_userpart_from_sip,
        getstate().config.system.SYS_WEBRTC_SERVER_URI,
        getstate().user.properties.SIP_ADDRESS,
        getstate().user.username,
        sessionid,
        "" //TODO : no fixed values
      );

    dispatch({
      type: ActionTypes.SIP_UPDATEREGISTEREDENDPOINT_STARTED,
      payload: {
        securityToken: securityToken,
        registerExpires: registerExpires,
        contact: contact,
      },
    });

    SipService.updateRegisteredEndpoint(
      registerExpires,
      contact,
      getstate().config.server,
      securityToken,
      dispatch
    )
      .done(data => {
        dispatch({ type: ActionTypes.SIP_UPDATEREGISTEREDENDPOINT_COMPLETED });
      })
      .fail((xhr, ajaxOptions, thrownError) => {
        dispatch({
          type: ActionTypes.SIP_UPDATEREGISTEREDENDPOINT_ERROR,
          payload: { xhr: xhr },
        });
      });
  };
}






// WEBPACK FOOTER //
// ./src/actions/sipActions.js